export const formats = {
  date: "DD.MM.YYYY",
  time: "HH:mm",
  datetime : "DD.MM.YYYY. HH:mm",
  timedate: "HH:mm, DD.MM.YYYY.",
  isodate: "YYYY-MM-DD",
  supported_date_formats: [ 'DDMM HHmm', 'DD.MM HH:mm','DD.MM.YYYY', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm' ],
}
